export default __webpack_public_path__ + "static/hpe-b498d9e42cfb0512813c9fea64966faa.png";